/**
 * Legacy SmartChart component stub
 * This is a placeholder to maintain compatibility with visualization components
 * TODO: Refactor visualization components to use new platinum table system
 */

import React from 'react'
import { Box, Typography } from '@mui/material'

interface SmartChartProps {
  platinumData: any
  displayName?: string
  chartKind?: string
  selectedDataType?: string
  selectedCategories?: string[]
  selectedMonths?: string[]
  selectedMonth?: string
  chartSettings?: any
  displayOptions?: any
  [key: string]: any
}

export const SmartChart: React.FC<SmartChartProps> = (props) => {
  return (
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="body1" color="text.secondary">
        SmartChart component has been deprecated. Please refactor to use PlatinumGraphs.
      </Typography>
    </Box>
  )
}
